module.exports = __webpack_public_path__ + "img/tab_huasuhui_1.cb38f907.png";